export const PROFESSIONAL_INSTALLATION_PERMIT_FEE = 72
export const NO_EMC_FABRICATION_MULTIPLIER = 1.39

const getInstallationOptionDescription = (option) => {
  if (!option) return ''
  if (typeof option === 'string') {
    try {
      const parsed = JSON.parse(option)
      if (parsed && typeof parsed === 'object') {
        return parsed.description || ''
      }
    } catch (err) {
      // Plain description string
    }
    return option
  }
  return option.description || ''
}

export const isProfessionalInstallationOption = (option) => {
  return getInstallationOptionDescription(option).includes('Professional')
}

export const getProfessionalInstallationPermitFee = (option) => {
  return isProfessionalInstallationOption(option) ? PROFESSIONAL_INSTALLATION_PERMIT_FEE : 0
}

export const applyNoEmcFabricationMultiplier = (amount, noEmc) => {
  const value = Number(amount) || 0
  if (!noEmc) return value
  return value * NO_EMC_FABRICATION_MULTIPLIER
}
